import { Box, Typography, useTheme } from '@mui/material';
import { AlarmTriggerConditionItem } from 'src/components';
import { getUIOperatorSign } from 'src/features/alarm-rules-details/utils/getUIOperatorSign';
import { ConditionItem } from 'src/types/alarms';

type Props = {
  isExtendedRow: boolean;
  condition: ConditionItem;
};

export const AlarmConditionItem = ({ isExtendedRow, condition }: Props) => {
  const theme = useTheme();
  const value = condition?.triggerValue || condition?.clearingValue;
  const uiOperatorSign = getUIOperatorSign(condition?.operator);

  return (
    <Box
      key={condition.inputId}
      sx={{ display: 'flex', alignItems: 'center' }}
      data-sm={condition?.inputId}
    >
      <Box sx={{ margin: '0 3px' }}>
        {isExtendedRow && (
          <Typography sx={{ color: theme.palette.grey[500], fontSize: '12px' }}>AND</Typography>
        )}
      </Box>
      <AlarmTriggerConditionItem
        displayedCondition={`${condition?.tag?.tagDisplayName} ${uiOperatorSign} ${value}`}
      />
    </Box>
  );
};
